"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _react = _interopRequireDefault(require("react"));
var _MenuDropdownButton = _interopRequireDefault(require("../../atoms/MenuDropdownButton/MenuDropdownButton"));
var _Menu2 = _interopRequireDefault(require("./Menu.styles"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var APMenu = function APMenu(_ref) {
  var buttonTitle = _ref.buttonTitle,
    userAccount = _ref.userAccount,
    icon = _ref.icon,
    onClose = _ref.onClose,
    open = _ref.open,
    anchorEl = _ref.anchorEl,
    setOpen = _ref.setOpen,
    disableBackdropClick = _ref.disableBackdropClick,
    children = _ref.children,
    hideIcon = _ref.hideIcon,
    buttonContent = _ref.buttonContent,
    buttonProps = _ref.buttonProps,
    menuProps = _ref.menuProps,
    menuIconProps = _ref.menuIconProps,
    lightHeader = _ref.lightHeader,
    actions = _ref.actions;
  var classes = (0, _Menu2["default"])({
    actions: actions
  });
  var handleClick = function handleClick(event) {
    if (!open) {
      return setOpen(event.currentTarget);
    }
    return setOpen(null);
  };
  var handleClose = function handleClose() {
    if (!disableBackdropClick) {
      setOpen(null);
      if (onClose) {
        onClose();
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, buttonContent ? /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    onClick: handleClick,
    className: classes.menuIconWrapper
  }, buttonProps), buttonContent) : !icon ? /*#__PURE__*/_react["default"].createElement(_MenuDropdownButton["default"], {
    buttonTitle: buttonTitle || '',
    userAccount: userAccount,
    handleClick: handleClick,
    buttonProps: buttonProps,
    menuIconProps: menuIconProps,
    hideIcon: hideIcon
  }) : /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    onClick: handleClick,
    className: classes.menuButtonAPMenu
  }, buttonProps, {
    startIcon: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      className: classes.buttonIconAPMenu,
      icon: icon
    })
  }), buttonTitle), /*#__PURE__*/_react["default"].createElement(_Menu["default"], _extends({
    getContentAnchorEl: null,
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    keepMounted: true,
    open: open,
    onClose: handleClose
  }, menuProps, {
    className: (0, _clsx["default"])(lightHeader ? classes.menuContainer : '', classes.menuList)
  }), children));
};
var _default = APMenu;
exports["default"] = _default;